import { render, staticRenderFns } from "./liveArea.vue?vue&type=template&id=71bf0534&scoped=true"
import script from "./liveArea.vue?vue&type=script&lang=js"
export * from "./liveArea.vue?vue&type=script&lang=js"
import style0 from "./liveArea.vue?vue&type=style&index=0&id=71bf0534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf0534",
  null
  
)

export default component.exports